export enum StatusCadastro {
    Inativo = 0,
    Ativo = 1,
    Removido = 2
}
